import { BaseWebComponentView } from '../../../../../../framework/BaseWebComponentView';
import { API_TYPE_POLICY_FILTER, WEB_COMPONENT_GRID_VIEW } from '../../../../../../webcomponents.constants';
import { ColumnDetails, ColumnType } from '../../../../../../grid/types/common';
import { ChildGroupColumn, ChildGroupColumnKeys } from '../types';
import { translateFn } from '../../../../../../utils/translator.helper';
import { nameRenderer, policyRenderer } from './childGroupsGridRenderers';
import { ChildGroupsGridDataProvider } from '../dataProvider/ChildGroupsGridDataProvider';
import { dataGridStrings } from '../../../../../../grid/utils/gridStrings';
import { GridFiltersHelper } from '../../../../../../grid/gridFilters/helpers/GridFiltersHelper';

export class ChildGroupsGridView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
    this.dom.$grid = this.shadow.querySelector(WEB_COMPONENT_GRID_VIEW);

    if (this.dom.$grid.injectDependencies) {
      this.dom.$grid.injectDependencies(this.dependencies);
      this.dom.$grid.start().then().catch(console.error);
    }
  }

  buildView(data: any) {
    const columnDetails: Array<ColumnDetails<ChildGroupColumn, ChildGroupColumnKeys>> = [
      {
        key: ChildGroupColumnKeys.NAME,
        column: ChildGroupColumn.NAME,
        columnName: translateFn('Entity name'),
        type: ColumnType.STRING,
        removable: false,
        sortable: true,
      },
      {
        key: ChildGroupColumnKeys.POLICY,
        column: ChildGroupColumn.POLICY,
        columnName: translateFn('Current policy'),
        type: ColumnType.BACKEND_SINGLE_SELECT,
        removable: false,
        sortable: true,
      },
    ];

    this.dom.$grid.propertiesSet = false;
    this.dom.$grid.allColumnDetails = columnDetails;
    this.dom.$grid.columnRenderers = {
      [ChildGroupColumnKeys.NAME]: nameRenderer,
      [ChildGroupColumnKeys.POLICY]: policyRenderer,
    };
    this.dom.$grid.dataProvider = new ChildGroupsGridDataProvider();
    this.dom.$grid.dataProvider.injectDependencies(this.dependencies);
    this.dom.$grid.hideHeaderActions = true;
    this.dom.$grid.hideFiltersToggle = true;
    this.dom.$grid.hideResetFilters = true;
    this.dom.$grid.hasPagination = true;
    this.dom.$grid.shouldLoadAsync = true;
    this.dom.$grid.isCompactViewChecked = false;
    this.dom.$grid.dynamicHeight = true;
    this.dom.$grid.viewId = 'child-groups-grid-view-id';
    this.dom.$grid.defaultFlexGrowColumn = ChildGroupColumnKeys.POLICY;
    this.dom.$grid.columns = [ChildGroupColumn.NAME, ChildGroupColumn.POLICY];
    this.dom.$grid.columnConfigs = [
      {
        key: ChildGroupColumnKeys.NAME,
        width: '220px',
      },
      {
        key: ChildGroupColumnKeys.POLICY,
        width: '220px',
      },
    ];
    this.dom.$grid.predefinedFiltersKeys = [ChildGroupColumnKeys.NAME, ChildGroupColumnKeys.POLICY];
    this.dom.$grid.filters = [
      {
        [ChildGroupColumnKeys.NAME]: { contains: '' },
      },
      {
        [ChildGroupColumnKeys.POLICY]: { equals: null },
      },
    ];
    this.dom.$grid.isCompactViewChecked = false;
    this.dom.$grid.pageSize = 20;
    this.dom.$grid.filtersUiConfigs = [
      {
        key: ChildGroupColumnKeys.NAME,
        config: {
          placeholder: translateFn('Search entities'),
        },
      },
      {
        key: ChildGroupColumnKeys.POLICY,
        config: {
          placeholder: translateFn('Select policy'),
          apiType: API_TYPE_POLICY_FILTER,
          canDelete: true,
          populateFilterCallback: GridFiltersHelper.populateFilterCallback,
        },
      },
    ];
    this.dom.$grid.customStrings = {
      noSearchResultsString: translateFn('No entities'),
      dataLoadingFailed: dataGridStrings().dataLoadingFailed,
    };
    this.dom.$grid.propertiesSet = true;
  }

  clearWrapper() {
    this.dom.$wrapper.innerHTML = '';
  }
}
